import { createSlice } from '@reduxjs/toolkit';

export const PAYMENT_STATUS = {
  INITIATED: 'INITIATED',
  SUCCESS: 'SUCCESS',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
}

const imagePaymentFormPopup = createSlice({
  name: 'imagePaymentFormPopup',
  initialState: {
    isActive: false,
    paymentStatus: null,
    renderingPriceInfo: {},
    isAmountForRenderSufficient: false,
    remainingAmountForRender: 0,
    disabledRenderJobId: null,
    clientSecretKey: null,
    isStripeLoading: false,
  },
  reducers: {
    show: (state, { payload }) => {
      state.isActive = true;
    },
    close: (state) => {
      state.isActive = null;
      state.paymentStatus = null;
      state.disabledRenderJobId = null;
      state.clientSecretKey = null;
      state.isStripeLoading = false;
    },
    setStatus: (state, { payload }) => {
      state.paymentStatus = payload;
    },
    setRenderingPriceInfo: (state, { payload }) => {
      state.renderingPriceInfo = payload;
    },
    setIsAmountForRenderSufficient: (state, { payload }) => {
      state.isAmountForRenderSufficient = payload;
    },
    setRemainingAmountForRender: (state, { payload }) => {
      state.remainingAmountForRender = payload;
    },
    setDisabledRenderJobId: (state, { payload }) => {
      state.disabledRenderJobId = payload;
    },
    setTotalAmountForRender: (state, { payload }) => {
      state.totalAmountForRender = payload;
    },
    setClientSecretKey: (state, { payload }) => {
      state.clientSecretKey = payload;
    },
    setIsStripeLoading: (state, { payload }) => {
      state.isStripeLoading = payload;
    },
  },
});

export const imagePaymentFormPopupActions = imagePaymentFormPopup.actions;
export const imagePaymentFormPopupReducer = imagePaymentFormPopup.reducer;
export default imagePaymentFormPopupReducer;

export const selectIsPaymentFormActive = (state) => state.imagePaymentFormPopup.isActive;
export const selectPaymentStatus = (state) => state.imagePaymentFormPopup.paymentStatus;
export const selectIsPaymentInitiated = (state) => state.imagePaymentFormPopup.paymentStatus === PAYMENT_STATUS.INITIATED;
export const selectIsPaymentProcessing = (state) => state.imagePaymentFormPopup.paymentStatus === PAYMENT_STATUS.PROCESSING;
export const selectIsPaymentSuccessful = (state) => state.imagePaymentFormPopup.paymentStatus === PAYMENT_STATUS.SUCCESS;
export const selectIsPaymentFailed = (state) => state.imagePaymentFormPopup.paymentStatus === PAYMENT_STATUS.FAILED;

export const selectRenderingPriceInfo = (state) => state.imagePaymentFormPopup.renderingPriceInfo;
export const selectOrgAvailableBalance = (state) => state.imagePaymentFormPopup.renderingPriceInfo.amount;
export const selectPerImageStandardPrice = (state) => state.imagePaymentFormPopup.renderingPriceInfo.standard;
export const selectPerImagePremiumPrice = (state) => state.imagePaymentFormPopup.renderingPriceInfo.premium;
export const selectPerImageUhdPrice = (state) => state.imagePaymentFormPopup.renderingPriceInfo.uhd_price;
export const selectSubscriptionPlanExpiredPerImagePrice = (state) => state.imagePaymentFormPopup.renderingPriceInfo.expired_subscription_rate;
export const selectIsAmountForRenderSufficient = (state) => state.imagePaymentFormPopup.isAmountForRenderSufficient;
export const selectRemainingAmountForRender = (state) => state.imagePaymentFormPopup.remainingAmountForRender;
export const selectTotalAmountForRender = (state) => state.imagePaymentFormPopup.totalAmountForRender;

export const selectDisabledRenderJobId = (state) => state.imagePaymentFormPopup.disabledRenderJobId;

export const selectClientSecretKey = (state) => state.imagePaymentFormPopup.clientSecretKey;
export const selectIsStripeLoading = (state) => state.imagePaymentFormPopup.isStripeLoading;